// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class CompetitorProductSummary {
  readonly id: string;
  readonly name: string;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
  }

  static zero(): CompetitorProductSummary {
    const zeroValues: ExcludeMethodsDeep<CompetitorProductSummary> = {
      id: NIL_UUID,
      name: '',
    };
    return new CompetitorProductSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CompetitorProductSummaryWireFormat = {
  id: string;
  name: string;
};

type NewCompetitorProductSummaryProps = PartialDeep<
  CompetitorProductSummary,
  { recurseIntoArrays: true }
>;
export const NewCompetitorProductSummary: (
  props: NewCompetitorProductSummaryProps,
) => CompetitorProductSummary = (props) => new CompetitorProductSummary(props);

type NewCompetitorProductSummaryFromWireFormatProps = PartialDeep<
  CompetitorProductSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCompetitorProductSummaryFromWireFormat: (
  props: NewCompetitorProductSummaryFromWireFormatProps,
) => CompetitorProductSummary = (props) => new CompetitorProductSummary(props);
